import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import { graphql, QueryRenderer } from "react-relay";
import environment from "../../Environment";

const query = graphql`
    query PageSelector_Query($id: ID!) {
        node(id: $id) {
            __typename
            name
            id
            siblings {
                name
                id
            }
        }
    }

`;

export default class PageSelector extends Component {
  static propTypes = {
    name: PropTypes.string,
    id: PropTypes.string,
    list: PropTypes.arrayOf(PropTypes.object),
    listType: PropTypes.oneOf("Principle", "Theme", "Element")
  };

  constructor(props) {
    super(props);
    this.state = { redirectTo: false };
    this.onSelect = this.onSelect.bind(this);
  }

  onSelect(event) {
    console.log(event.target.value);
    this.setState({ redirectTo: `/elements/${event.target.value}/`})
  }

  render() {
    let { name, id, list, listType } = this.props;
    if (this.state.redirectTo) {
      return <Redirect to={this.state.redirectTo} push />
    }

    if (list) {
      return (<select className={`selector__${listType}`} onChange={this.onSelect}>
        <option>
          Select a {listType}
        </option>
        {list.map(item => <option key={item.id} value={item.id}>{item.name}</option>)}
      </select>);
    }

    return (<QueryRenderer
      query={query}
      environment={environment}
      variables={{ id: this.props.id }}
      render={({ error, props }) => {

        if (error) {
          <select>
            <option>Error fetching selection.</option>
          </select>
        }

        if (!props) {
          return (<select>
            <option selected value={id}>{name}</option>
          </select>);
        }
        

        console.log(props.node.siblings);
        console.log("Props Loool", props.node.__typename);
        return (
        <React.Fragment>
          <select data-item="clor-3" className={`selector__${props.node && props.node.__typename}`} id={id} value={id} onChange={this.onSelect}>
            <option value={id}>{name}</option>
            {props.node.siblings.map(sibling => <option key={sibling.id} value={sibling.id}>{sibling.name}</option>)}
          </select>
          
          
        </React.Fragment>);

        return <div></div>

      }} />)

  }
}




// WEBPACK FOOTER //
// ./src/Components/PageSelector/index.js